// extracted by mini-css-extract-plugin
export var progressBar = "_i6-0";
export var progressBarInner = "_i6-1";